import React from 'react';
import {createRoot} from "react-dom/client";
import PreSignUpPage from '../../../components/login/pre-sign-up/PreSignUpPage.jsx';
import JshModule from "@core/scripts/helper/jsh-module";

const {moduleScope, config} = JshModule('checkout/login/presignup-page');

const {loginPageConfig} = config

createRoot(moduleScope).render(
    <PreSignUpPage
        texts={loginPageConfig.texts}
        siteKeyPresignup={loginPageConfig.siteKeyPresignup}
        isCaptchaEnabled={loginPageConfig.isCaptchaEnabled}
        captchaLang={loginPageConfig.captchaLang}
        preSignUpPageLandmark={loginPageConfig.preSignUpPageLandmark}
        guestLoginPageLandmark={loginPageConfig.guestLoginPageLandmark}
        isGuestCheckoutEnabled={loginPageConfig.isGuestCheckoutEnabled}
        isGuestNewsletterEnabled={loginPageConfig.isGuestNewsletterEnabled}
    />
);